import React, { useState } from 'react';
import PageContainer from '../components/PageContainer';
import { FiHeart, FiMessageCircle, FiPlus, FiUpload, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion, AnimatePresence } from 'framer-motion';

const feedItems = [
  { id: 1, image: "https://images.unsplash.com/photo-1493225457124-a1a2a5f5cb46?q=80&w=800&auto=format&fit=crop", likes: "12.4k", comments: "342", caption: "Soundcheck vibes. NYC you ready? 🎸🔥 #tourlife" },
  { id: 2, image: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?q=80&w=800&auto=format&fit=crop", likes: "8.9k", comments: "156", caption: "Late nights in the studio. Magic is happening. 🎧✨" },
  { id: 3, image: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=800&auto=format&fit=crop", likes: "20.1k", comments: "890", caption: "Thank you LA! What a night! 🤘" },
  { id: 4, image: "https://images.unsplash.com/photo-1473172740926-0e1bba61d4a0?q=80&w=800&auto=format&fit=crop", likes: "15.2k", comments: "445", caption: "Finding inspiration everywhere. 🌻" },
];

export default function SocialFeed() {
  const [showSubmitModal, setShowSubmitModal] = useState(false);

  return (
    <PageContainer title="Fan Showcase">
      <div className="flex flex-col items-center mb-12">
        <p className="subtitle-typewriter mb-6 text-center max-w-xl">
          This is your stage. Share your photos, art, and memories with the community.
        </p>
        <button 
          onClick={() => setShowSubmitModal(true)}
          className="flex items-center gap-2 bg-sun-yellow text-black px-8 py-3 rounded-full font-bold hover:bg-white transition-all transform hover:scale-105"
        >
          <SafeIcon icon={FiPlus} /> Submit Your Content
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {feedItems.map((item) => (
          <div key={item.id} className="group relative aspect-square bg-black overflow-hidden rounded-lg border border-white/5">
            <img 
              src={item.image} 
              alt="Social Post" 
              className="w-full h-full object-cover opacity-90 group-hover:opacity-40 transition-opacity duration-300"
            />
            <div className="absolute inset-0 flex flex-col justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4 text-center">
              <div className="flex gap-4 mb-2 text-white font-bold">
                <span className="flex items-center gap-1 text-sm"><SafeIcon icon={FiHeart} /> {item.likes}</span>
                <span className="flex items-center gap-1 text-sm"><SafeIcon icon={FiMessageCircle} /> {item.comments}</span>
              </div>
              <p className="font-typewriter text-[10px] text-gray-200 line-clamp-2">{item.caption}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Submission Modal */}
      <AnimatePresence>
        {showSubmitModal && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <motion.div 
              initial={{ opacity: 0 }} 
              animate={{ opacity: 1 }} 
              exit={{ opacity: 0 }}
              onClick={() => setShowSubmitModal(false)}
              className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            />
            <motion.div 
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="glass-panel w-full max-w-lg p-8 relative z-10"
            >
              <button 
                onClick={() => setShowSubmitModal(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-white"
              >
                <SafeIcon icon={FiX} className="w-6 h-6" />
              </button>
              
              <h3 className="text-2xl font-display text-sun-yellow mb-2">Submit Content</h3>
              <p className="subtitle-typewriter mb-6 text-sm">Contribute to the official MB fan archive.</p>
              
              <div className="space-y-4">
                <div className="border-2 border-dashed border-gray-700 rounded-xl p-8 text-center hover:border-sun-yellow transition-colors cursor-pointer group">
                  <SafeIcon icon={FiUpload} className="w-10 h-10 text-gray-600 group-hover:text-sun-yellow mx-auto mb-2" />
                  <p className="font-typewriter text-sm text-gray-500">Drop your photo here or click to browse</p>
                </div>
                
                <div>
                  <label className="block font-typewriter text-xs text-gray-400 mb-1">Caption</label>
                  <textarea 
                    className="input-grunge w-full h-24 resize-none"
                    placeholder="Tell us about this moment..."
                  />
                </div>
                
                <button className="w-full bg-sun-yellow text-black font-bold py-3 rounded uppercase hover:bg-white transition-colors">
                  Post to Community
                </button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </PageContainer>
  );
}